import { setCSSCustomProperty } from "./utils/css.utils";
export var UIController = {
    init: function () {
        var windowResizeHandler = function () {
            var _a, _b;
            var adminBar = document.querySelector('#wpadminbar');
            var nav = document.querySelector('#site-nav');
            setCSSCustomProperty('--wp-admin-bar-height', ((_a = adminBar === null || adminBar === void 0 ? void 0 : adminBar.clientHeight) !== null && _a !== void 0 ? _a : 0) + 'px');
            setCSSCustomProperty('--nav-height', ((_b = nav === null || nav === void 0 ? void 0 : nav.clientHeight) !== null && _b !== void 0 ? _b : 0) + 'px');
        };
        window.addEventListener('resize', windowResizeHandler);
    }
};
